import React from 'react';
import './BrandCarousel.css';

// Import all brand logos
import aandw from '../aandw.png';
import beta5 from '../beta5.png';
import carnitas from '../carnitas.png';
import cartems from '../cartems.png';
import elmercat from '../elmercat.png';
import kindredculture from '../kindredculture.png';
import kirin from '../kirin.png';
import kirks from '../kirks.webp';
import kitskitchen from '../kitskitchen.png';
import konscious from '../konscious.png';
import kukkijar from '../kukkijar.png';
import labise from '../labise.png';
import mochido from '../mochido.png';
import planted from '../planted.png';
import tayybeh from '../tayybeh.png';
import tolivefor from '../tolivefor.png';

const BrandCarousel: React.FC = () => {
  const brands = [
    { name: 'A&W', logo: aandw },
    { name: 'Beta5', logo: beta5 },
    { name: 'Carnitas', logo: carnitas },
    { name: 'Cartems', logo: cartems },
    { name: 'Elmer Cat', logo: elmercat },
    { name: 'Kindred Culture', logo: kindredculture },
    { name: 'Kirin', logo: kirin },
    { name: "Kirk's Kefir", logo: kirks },
    { name: 'Kits Kitchen', logo: kitskitchen },
    { name: 'Konscious', logo: konscious },
    { name: 'Kukki Jar', logo: kukkijar },
    { name: 'La Bise', logo: labise },
    { name: 'Mochido', logo: mochido },
    { name: 'Planted', logo: planted },
    { name: 'Tayybeh', logo: tayybeh },
    { name: 'To Live For', logo: tolivefor }
  ];

  // Duplicate the brands array for seamless scrolling
  const duplicatedBrands = [...brands, ...brands];

  return (
    <section className="brand-carousel">
      <div className="container">
        <div className="carousel-header">
          <h2>Where Successful Food Brands Scale</h2>
          <p>Join 500+ businesses that chose our kitchens to grow</p>
        </div>
      </div>
      
      <div className="carousel-wrapper">
        <div className="carousel-track">
          {duplicatedBrands.map((brand, index) => (
            <div key={index} className="brand-item">
              <img src={brand.logo} alt={brand.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;